/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import Loader from 'components/atoms/loader';
import { Container } from './styles';

const MyAccountCompanyData = () => {
  const { profile, request } = useSelector<ApplicationState, ProfileState>(
    (state) => state.storage.profile,
  );
  return (
    <Container>
      <div className="container-fluid">
        <div className="card">
          {request.loading ? (
            <Loader />
          ) : (
            <div className="card-body">
              <h4 className="card-title font-weight-bold">
                {profile?.company_data?.data?.razao_social}
              </h4>
              <p className="title"> Nome Fantasia: {profile?.company_data?.data.nome_fantasia} </p>
              <hr />
              <p className="mb-0">
                <label className="font-weight-bold">CNPJ:</label>
              </p>
              <div className="row">
                <div className="col-md-3">
                  <p>{profile?.company_data?.data.cnpj}</p>
                </div>
                <div className="col-md-9">
                  <p className="font-weight-bold">
                    IE:
                    <span className="font-weight-normal">
                      {profile?.company_data?.data.inscricao_estadual}
                    </span>
                  </p>
                </div>
              </div>
              <p className="font-weight-bold mb-1">Telefone:</p>
              <p>{`(${profile?.company_data?.data.ddd_telefone}) ${profile?.company_data?.data.numero_telefone}`}</p>
              <p className="font-weight-bold mb-1">Email:</p>
              <p>{profile?.company_data?.data.email}</p>
              <p className="font-weight-bold mb-1">Site</p>
              <p>{profile?.company_data?.data.website}</p>
              <p className="font-weight-bold mb-1">Endereço:</p>
              <div className="row mb-2">
                <div className="col-md-12">
                  <span>
                    {profile?.company_data?.data.endereco}, {profile?.company_data?.data.numero}
                  </span>
                  <span className="font-weight-bold"> Compl.:</span>
                  <span> {profile?.company_data?.data.complemento}</span>
                  <span className="font-weight-bold"> Bairro: </span>
                  <span>{profile?.company_data?.data.bairro}</span>
                  <span className="font-weight-bold"> CEP: </span>
                  <span>{profile?.company_data?.data.cep}</span>
                </div>
              </div>
              <p className="font-weight-bold mb-1">Estado:</p>
              <p>{profile?.company_data?.estado}</p>
              <p className="font-weight-bold"> Cidade:</p>
              <p>{profile?.company_data?.cidade}</p>
              <b />
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

export default MyAccountCompanyData;
